import $ from 'jquery';
import { Globals } from '../Utils';

require('bootstrap/js/dropdown.js'); //source code has been changed manualy line 17 https://iservice.sos-kd.org/browse/DIGSP-4797
require('../plugins/DropDownOnHover.js');
require('../plugins/StickyNavigation.js');
import AnchorNavigationController from '../AnchorNavigationController.js';

export default class NavigationController {
    constructor() {
        this.STICKY_NAV_SELECTOR = '.sos-main-nav .navbar-collapse';
        this.STICKY_NAV_SELECTOR_MOBILE = '.mobile-nav';
        this.STICKY_NAV_OFFSET = -10;

        this.DROPDOWN_HOVER_DELAY = 0;

        this.addStickyNav();
        this.initDropdown();
        NavigationController.initSearchFunction();
        NavigationController.assignColumns();
    }

    addStickyNav() {
        if (!Globals.IsMobile) {
            const stickyNav = $(this.STICKY_NAV_SELECTOR);
            if (stickyNav.length > 0) {
                /* eslint-disable-next-line */
                new window.Waypoint.Sticky({
                    element: stickyNav,
                    handler() {},
                    offset: this.STICKY_NAV_OFFSET,
                });
                AnchorNavigationController.init();
            }
        }
        else {
            const stickyNavMobile = $(this.STICKY_NAV_SELECTOR_MOBILE);
            let lastKnownScrollPosition = 0;
            let previousScrollPosition = 0;
            let ticking = false;
            $(window).scroll(() => {
                lastKnownScrollPosition = window.scrollY;
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        if (lastKnownScrollPosition <= 600 || lastKnownScrollPosition < previousScrollPosition) {
                            stickyNavMobile.slideDown();
                        }
                        else {
                            stickyNavMobile.slideUp();
                        }
                        ticking = false;
                        previousScrollPosition = lastKnownScrollPosition;
                    });
                    ticking = true;
                }
            });
        }
    }

    initDropdown() {
        $('.js-activated')
            .dropdownHover({
                instantlyCloseOthers: false,
                delay: this.DROPDOWN_HOVER_DELAY,
            })
            .dropdown();

        $('.mobile-nav .navbar-header .navbar-toggle').click((e) => {
            $(e.currentTarget).toggleClass('open');
        });
    }

    static initSearchFunction() {
        $('.search input').keypress((e) => { // eslint-disable-line consistent-return
            if (e.which === 13 || e.which === 10) {
                const searchQuery = e.currentTarget.value;
                NavigationController.searchSubmit(searchQuery);
                return false;
            }
        });

        $('.search .btn').mousedown((e) => {
            const searchQuery = $(e.currentTarget).siblings('input').val();
            NavigationController.searchSubmit(searchQuery);
            return false;
        });
    }

    static assignColumns() {
        if (!Globals.IsMobile) {
            $('.dropdown-menu.sos-main-nav-dropdown-menu').each((index, elem) => {
                let cols = $(elem).find('.sos-main-nav-content.grid > div').length;
                cols = Math.floor(12 / cols);
                $(elem).find('.sos-main-nav-content.grid .inner').addClass(`col-sm-${cols}`);
            });
        }
    }

    static searchSubmit(searchQuery) {
        const searchTeaserParams = `?q=${searchQuery}`;
        window.location.href = `/searchresults${searchTeaserParams}`;
        return false;
    }

    static init() {
        $(document).ready(() => {
            new NavigationController(); // eslint-disable-line no-new
        });
    }
}
